import { useEffect, useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import CardTask from "../CardTask/CardTask";

const ContractItem = (props) => {
  const { currentUser } = useAuth();
  const contract = props.contract;
  const dateUpdated = new Date(contract.dateUpdated);
  const [perkIcon, setPerkIcon] = useState();
  const [skillIcon, setSkillIcon] = useState();

  const [isFreeToClaim, setIsFreeToClaim] = useState(false);
  const [buttonText, setButtonText] = useState(false);

  function getContractHandler() {
    props.onGetContract(contract.id, contract.party);
  }

  useEffect(() => {
    getContractActions();
  }, []);

  function getContractActions() {
    let claimed = false;
    let userClaimed = false;
    if (contract.claims && contract.claims[currentUser.uid]) {
      claimed = true;
      userClaimed = Object.keys(contract.claims)[0];
    }
    if (contract.party && contract.party != currentUser.uid) {
      setIsFreeToClaim(false);
      return;
      // работает другой участник
    }
    if (userClaimed && userClaimed != currentUser.uid) {
      setIsFreeToClaim(false);
      return;
      //запросил другой участник
    }
    switch (+contract.status) {
      case 0: //  открыта задача
        if (!claimed) {
          setIsFreeToClaim(true);
          setButtonText("Откликнуться");
        } else {
          setIsFreeToClaim(false);
          // отправлен запрос
        }
        return

      case 1: //  задача взята(назначена)
        setIsFreeToClaim(false);
        setButtonText("Выполнено");
        return

      case 2: //выполнено| закрыта
        setIsFreeToClaim(false);
        return

      default:
        setIsFreeToClaim(false);
        return;
    }
  }
  
  return (
    <>
      <CardTask
        contract={contract}
        onTakeContract={isFreeToClaim && getContractHandler}
        button={isFreeToClaim && buttonText}
        state={contract.status == 2 && "inactive"}
      />

    </>
  );
};

export default ContractItem;
